import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, FormControl, MenuItem, Select, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { IntervalsObject } from '../../../../../interfaces/meeting';
import { RootState } from '../../../../../utils/store';
import { checkIfInIntervals } from '../helpers';

interface SelectTimeComponnentProps {
  intervals: IntervalsObject[];
  selected: string;
  setSelected: (value: string) => void;
  disabled: boolean;
  list: string[];
  isDisabled?: boolean;
}

const styles = {
  selectLabel: {
    '& .MuiFormLabel-root': {
      fontFamily: 'Schibsted Grotesk',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '12px',
      letterSpacing: '0em',
      textAlign: 'left',
      left: '0.1rem',
      color: '#878787',
      padding: '0px 0px 5px 8px',
    },
    '& .MuiSelect-select': {
      paddingTop: '8px!important',
    },
    '& .MuiFilledInput-input:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectLabelHasValue: {
    '& .MuiFormLabel-root': {
      fontSize: '12px',
      color: 'black',
    },
    '& .MuiFilledInput-input': {
      backgroundColor: 'white',
    },
    '& .MuiFilledInput-input:focus': {
      backgroundColor: 'white',
    },
    '& .MuiFilledInput-input:hover': {
      backgroundColor: 'white',
    },
  },
  dropdown: {
    padding: '0px 8px 8px 8px',
    borderRadius: '6px',
    backgroundColor: '#00000008',
    '& .MuiNativeSelect-select': {
      padding: '0px',
    },
  },
  dropdownHasValue: {
    '& .MuiFormLabel-root': {
      fontSize: '12px',
      color: 'black',
    },
    backgroundColor: 'white!important',
    border: '1px solid rgba(0, 0, 0, 0.50)',
    '&:hover': {
      backgroundColor: 'white',
    },
  },
  menuItemText: {
    fontFamily: 'Schibsted Grotesk',
    fontsize: '14px',
    color: 'black',
    fontweight: 400,
    lineHeight: '17px',
    letterspacing: '0em',
    textalign: 'left',
    paddingTop: '10px',
  },
};

const SelectTimeComponent = ({
  intervals,
  selected,
  setSelected,
  disabled,
  list,
}: SelectTimeComponnentProps) => {
  const canAddInterval = useSelector(
    (state: RootState) => state.meetings.canAddInterval,
  );
  const handleChangeTime = (time: string) => {
    if (time) {
      setSelected(time);
    }
  };

  return (
    <FormControl
      disabled={disabled || (!canAddInterval && !selected)}
      fullWidth
      variant='filled'
      sx={{
        ...styles.selectLabel,
        ...(selected && styles.selectLabelHasValue),
      }}
    >
      <Select
        labelId='duration-select-label'
        readOnly={disabled}
        IconComponent={(props) => (
          <ExpandMoreIcon
            {...props}
            sx={{
              width: '30px',
              height: '30px',
            }}
          />
        )}
        sx={{
          ...styles.dropdown,
          ...(selected && styles.dropdownHasValue),
        }}
        disableUnderline
        value={
          selected &&
          Array.isArray(list) &&
          list.find((item) => item === selected)
            ? selected
            : '-'
        }
        onChange={(e) => handleChangeTime(e?.target?.value)}
      >
        <Box component='option' value='' style={{ display: 'none' }}>
          <FormattedMessage defaultMessage='Select Time' />
        </Box>
        {list.length > 0 &&
          list?.map((time, key) => {
            return (
              <MenuItem
                key={key}
                value={time}
                sx={{
                  ...styles.menuItemText,
                  display: checkIfInIntervals(time, intervals),
                }}
              >
                <Typography sx={styles.menuItemText} className='role-menuitem'>
                  {time}
                </Typography>
              </MenuItem>
            );
          })}
        ;
        <MenuItem
          value={'-'}
          sx={{
            ...styles.menuItemText,
            display: 'none',
          }}
        >
          <Typography sx={styles.menuItemText} className='role-menuitem'>
            <FormattedMessage defaultMessage='Select Time' />
          </Typography>
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default SelectTimeComponent;
